/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 6041:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'sliders-v-square';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f3f2';
var svgPathData = 'M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM200 224h-24v180c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V224H88c-13.3 0-24-10.7-24-24v-16c0-13.3 10.7-24 24-24h24v-52c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h24c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24zm184 104c0 13.3-10.7 24-24 24h-24v52c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-52h-24c-13.3 0-24-10.7-24-24v-16c0-13.3 10.7-24 24-24h24V108c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v180h24c13.3 0 24 10.7 24 24v16z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.TA = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 2986:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'times';
var width = 352;
var height = 512;
var ligatures = [];
var unicode = 'f00d';
var svgPathData = 'M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.GR = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 5071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CustomFieldForm_CustomFieldForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomFieldForm/CustomFieldForm.vue?vue&type=template&id=54ddd531
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form',{staticClass:"custom-field-form",attrs:{"action":_vm.formUrl,"method":_vm.localField.id ? 'PUT' : 'POST'},on:{"submitComplete":_vm.formSubmitted}},[_c('b-form-group',{attrs:{"label":_vm.$t('customFields.label')}},[_c('k-form-input',{attrs:{"name":"label","required":""},model:{value:(_vm.localField.label),callback:function ($$v) {_vm.$set(_vm.localField, "label", $$v)},expression:"localField.label"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('customFields.typeLabel')}},[_c('k-form-select',{attrs:{"name":"type","options":_vm.computedTypes,"required":"","clearable":false,"reduce":opt => opt.id},model:{value:(_vm.localField.type),callback:function ($$v) {_vm.$set(_vm.localField, "type", $$v)},expression:"localField.type"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('customFields.requiredLabel')}},[_c('b-form-radio-group',{attrs:{"name":"is_required"},model:{value:(_vm.localField.is_required),callback:function ($$v) {_vm.$set(_vm.localField, "is_required", $$v)},expression:"localField.is_required"}},[_c('b-form-radio',{attrs:{"value":true}},[_vm._v(" "+_vm._s(_vm.$t('interface.yes'))+" ")]),_c('b-form-radio',{attrs:{"value":false}},[_vm._v(" "+_vm._s(_vm.$t('interface.no'))+" ")])],1)],1),_c('b-form-group',{attrs:{"label":_vm.$t('customFields.usageLabel')}},[_c('k-form-checkbox-group',{attrs:{"name":"usage[]"},model:{value:(_vm.localField.usage),callback:function ($$v) {_vm.$set(_vm.localField, "usage", $$v)},expression:"localField.usage"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},_vm._l((_vm.usages),function(usage,i){return _c('k-form-checkbox',{key:i,staticClass:"col-6 mr-0",attrs:{"value":usage.id,"validate":"minChecked:1"}},[_vm._v(" "+_vm._s(usage.label)+" ")])}),1)])])],1),(_vm.getType(_vm.localField.type) && _vm.getType(_vm.localField.type).withOptions)?_c('div',[_c('b-form-group',{staticClass:"align-items-center mb-0",attrs:{"label":"Options :","label-cols":"auto"}},[_c('b-button',{staticClass:"mt-1",attrs:{"size":"sm"},on:{"click":function($event){return _vm.localField.options.push({ label: '' })}}},[_vm._v(" "+_vm._s(_vm.$t('interface.add'))+" ")])],1),_c('table',{staticClass:"table table-sm mb-0 mt-1"},_vm._l((_vm.localField.options),function(option,i){return _c('tr',{key:i},[_c('td',[_c('k-form-input',{attrs:{"name":"options[]","size":"sm","required":""},model:{value:(option.label),callback:function ($$v) {_vm.$set(option, "label", $$v)},expression:"option.label"}})],1),_c('td',{staticClass:"text-center delete-col"},[_c('font-awesome-icon',{staticClass:"text-danger",attrs:{"icon":['fas', 'times']},on:{"click":function($event){$event.preventDefault();return _vm.deleteOption(i)}}})],1)])}),0),(_vm.localField.options.length > 7)?_c('b-button',{staticClass:"mt-1",attrs:{"size":"sm"},on:{"click":function($event){return _vm.localField.options.push({ label: '' })}}},[_vm._v(" "+_vm._s(_vm.$t('interface.add'))+" ")]):_vm._e()],1):_vm._e()],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: ./src/mixins/CustomFieldsMixin.ts
var CustomFieldsMixin = __webpack_require__(7504);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomFieldForm/CustomFieldForm.ts?vue&type=script&lang=ts&external






var CustomFieldForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomFieldForm, _super);
    function CustomFieldForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localField = {};
        return _this;
    }
    Object.defineProperty(CustomFieldForm.prototype, "computedTypes", {
        get: function () {
            var types = Array.from(this.types);
            this.$kwCustomFields.fields.forEach(function (field) {
                var _a;
                types.push({
                    id: field.type,
                    label: (_a = field.formSelectLabel) !== null && _a !== void 0 ? _a : field.label
                });
            });
            return types;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomFieldForm.prototype, "formUrl", {
        get: function () {
            var url = '/config/custom_field';
            if (this.localField.id) {
                url += '/' + this.localField.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    CustomFieldForm.prototype.watchField = function (field) {
        var local = field ? JSON.parse(JSON.stringify(field)) : {
            type: this.types[0].id,
            is_required: false
        };
        if (!local.options) {
            local.options = [];
        }
        this.localField = local;
    };
    CustomFieldForm.prototype.formSubmitted = function (response) {
        return response;
    };
    CustomFieldForm.prototype.getType = function (key) {
        return this.types.find(function (type) { return type.id === key; });
    };
    CustomFieldForm.prototype.deleteOption = function (idx) {
        this.localField.options.splice(idx, 1);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomFieldForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], CustomFieldForm.prototype, "watchField", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('submitComplete')
    ], CustomFieldForm.prototype, "formSubmitted", null);
    CustomFieldForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormSelect: form_vue_.KFormSelect, KFormCheckboxGroup: form_vue_.KFormCheckboxGroup, KFormCheckbox: form_vue_.KFormCheckbox,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BFormRadio: external_bootstrap_vue_.BFormRadio, BButton: external_bootstrap_vue_.BButton,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            }
        })
    ], CustomFieldForm);
    return CustomFieldForm;
}((0,lib/* Mixins */.Xe)(CustomFieldsMixin/* default */.A)));
/* harmony default export */ var CustomFieldFormvue_type_script_lang_ts_external = (CustomFieldForm);

;// ./src/components/CustomFieldForm/CustomFieldForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomFieldForm_CustomFieldFormvue_type_script_lang_ts_external = (CustomFieldFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CustomFieldForm/CustomFieldForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomFieldForm_CustomFieldFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomFieldForm_CustomFieldForm = (component.exports);

/***/ }),

/***/ 9537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CustomFields_CustomFields; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomFields/CustomFields.vue?vue&type=template&id=5e836604
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-overlay',{attrs:{"show":_vm.loading}},[_c('DynamicList',{attrs:{"url":_vm.apiUrl,"columns":_vm.columns,"createTitle":_vm.$t('customFields.new'),"updateTitle":_vm.$t('customFields.edit'),"deleteMsg":_vm.$t('customFields.deleteMsg'),"sort":"order","customForm":_vm.formComponent,"datas":{ include: 'options' },"sortable":""},on:{"submitted":_vm.setCustomField,"deleted":_vm.deleteCustomField,"sorted":_vm.sorted}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: ./src/mixins/CustomFieldsMixin.ts
var CustomFieldsMixin = __webpack_require__(7504);
// EXTERNAL MODULE: ./src/components/CustomFieldForm/CustomFieldForm.vue + 3 modules
var CustomFieldForm = __webpack_require__(5071);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomFields/CustomFields.ts?vue&type=script&lang=ts&external







var CustomFields = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomFields, _super);
    function CustomFields() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formComponent = CustomFieldForm/* default */.A;
        _this.loading = false;
        _this.modal = false;
        _this.timeout = null;
        _this.sortedElements = null;
        return _this;
    }
    Object.defineProperty(CustomFields.prototype, "columns", {
        get: function () {
            var _this = this;
            return [
                {
                    label: this.$t('customFields.label'),
                    key: 'label'
                },
                {
                    label: this.$t('customFields.typeLabel'),
                    key: 'type',
                    show: function (val) {
                        var _a;
                        if (_this.defaultTypes.includes(val)) {
                            return _this.$t('customFields.types.' + val);
                        }
                        else {
                            return (_a = _this.$kwCustomFields.fields.find(function (field) { return field.type === val; })) === null || _a === void 0 ? void 0 : _a.label;
                        }
                    }
                },
                {
                    label: this.$t('customFields.requiredLabel'),
                    key: 'is_required',
                    show: function (val) { return val ? _this.$t('interface.yes') : _this.$t('interface.no'); }
                },
                {
                    label: this.$t('customFields.usageLabel'),
                    key: 'usage',
                    show: function (val) { return val.map(function (val) { var _a; return (_a = _this.usage(val)) === null || _a === void 0 ? void 0 : _a.label; }).join(', '); }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomFields.prototype, "apiUrl", {
        get: function () {
            return '/config/custom_field';
        },
        enumerable: false,
        configurable: true
    });
    CustomFields.prototype.sorted = function (elements) {
        this.sortedElements = elements;
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(this.saveSort, 500);
    };
    CustomFields.prototype.saveSort = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.sortedElements) {
                            return [2 /*return*/];
                        }
                        this.loading = true;
                        return [4 /*yield*/, this.$kwCustomFields.axios.post('/config/custom_field/order', {
                                fields: this.sortedElements.map(function (element) { return element.id; })
                            })
                                .finally(function () {
                                _this.loading = false;
                                _this.sortedElements = null;
                                _this.timeout = null;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomFields = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('customFields', ['setCustomField', 'deleteCustomField'])),
            components: {
                DynamicList: interface_vue_.DynamicList,
                BOverlay: external_bootstrap_vue_.BOverlay
            }
        })
    ], CustomFields);
    return CustomFields;
}((0,lib/* Mixins */.Xe)(CustomFieldsMixin/* default */.A)));
/* harmony default export */ var CustomFieldsvue_type_script_lang_ts_external = (CustomFields);

;// ./src/components/CustomFields/CustomFields.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomFields_CustomFieldsvue_type_script_lang_ts_external = (CustomFieldsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CustomFields/CustomFields.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomFields_CustomFieldsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomFields_CustomFields = (component.exports);

/***/ }),

/***/ 4174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_CustomFieldsView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CustomFieldsView.vue?vue&type=template&id=23be6259
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.$kwCustomFields.withPlacementSelection ? 'b-tabs' : 'div',{tag:"component",class:{ 'tabs-card': _vm.$kwCustomFields.withPlacementSelection }},[_c(_vm.$kwCustomFields.withPlacementSelection ? 'b-tab' : 'div',{tag:"component",attrs:{"title":_vm.$t('customFields.formTitle'),"lazy":""}},[_c('CustomFields')],1),(_vm.$kwCustomFields.withPlacementSelection)?[_c('b-tab',{attrs:{"title":_vm.$t('customFields.layout.layoutTitle'),"lazy":""}},[_c('DisplayLayouts')],1),_c('b-tab',{attrs:{"title":_vm.$t('customFields.layout.placement'),"lazy":""}},[_c('ViewConfiguration')],1)]:_vm._e()],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/CustomFields/CustomFields.vue + 3 modules
var CustomFields = __webpack_require__(9537);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DisplayLayouts/DisplayLayouts.vue?vue&type=template&id=2c96573c
var DisplayLayoutsvue_type_template_id_2c96573c_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DynamicList',{ref:"list",attrs:{"url":"/config/custom_field/layout","columns":_vm.columns,"createTitle":_vm.$t('customFields.layout.new'),"updateTitle":_vm.$t('customFields.layout.edit'),"deleteMsg":_vm.$t('customFields.layout.deleteMsg'),"customForm":_vm.formComponent,"modalSize":"xl"},on:{"submitted":_vm.submitted,"deleted":_vm.deleteLayout}})
}
var DisplayLayoutsvue_type_template_id_2c96573c_staticRenderFns = []


// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DisplayLayoutsForm/DisplayLayoutsForm.vue?vue&type=template&id=513d737a
var DisplayLayoutsFormvue_type_template_id_513d737a_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):[_c('k-form',{staticClass:"custom-fields-layouts",attrs:{"action":_vm.formAction,"method":_vm.formMethod,"value":_vm.layout},on:{"submitComplete":response => _vm.$emit('submitComplete', response)}},[_c('b-form-group',{attrs:{"label":_vm.$t('customFields.layout.elementTitle')}},[_c('k-form-checkbox-group',{staticClass:"mt-1",attrs:{"name":"usages[]"},model:{value:(_vm.layout.usages),callback:function ($$v) {_vm.$set(_vm.layout, "usages", $$v)},expression:"layout.usages"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},_vm._l((_vm.usages),function(usage,i){return _c('k-form-checkbox',{key:i,staticClass:"col-3 mr-0",attrs:{"value":usage.id,"validate":"minChecked:1"}},[_vm._v(" "+_vm._s(usage.label)+" ")])}),1)])])],1),_c('h3',{staticClass:"form-title-alt"},[_vm._v(" "+_vm._s(_vm.$t('customFields.layout.layoutTitle'))+" ")]),_c('p',{staticClass:"mb-2"},[_vm._v(" "+_vm._s(_vm.$t('customFields.layout.layoutExplain'))+" ")]),_c('k-form-checkbox',{staticClass:"text-danger font-weight-bold",model:{value:(_vm.layout.force_tab_display),callback:function ($$v) {_vm.$set(_vm.layout, "force_tab_display", $$v)},expression:"layout.force_tab_display"}},[_vm._v(" "+_vm._s(_vm.$t('customFields.layout.showInTab'))+" ")]),_c('b-form-group',{staticClass:"mt-4",attrs:{"label":_vm.$t('customFields.layout.layoutElement')}},[_c('draggable',{staticClass:"available-columns",attrs:{"group":{ name: 'layout', pull: 'clone', put: false },"list":_vm.columns,"clone":_vm.cloneColumn}},_vm._l((_vm.columns),function(column,i){return _c('div',{key:i,class:'field-columns col-' + i},[_c('div',{staticClass:"menu"},[_vm._v(" "+_vm._s(column.label)+" ")])])}),0)],1),_c('b-form-group',{attrs:{"label":_vm.$t('customFields.layout.layoutTitle')}},[_c('draggable',{staticClass:"row layout",attrs:{"group":{ name: 'layout', pull: 'clone' }},model:{value:(_vm.layout.layout),callback:function ($$v) {_vm.$set(_vm.layout, "layout", $$v)},expression:"layout.layout"}},_vm._l((_vm.layout.layout),function(content,i){return _c('div',{key:i,class:'field-columns col-' + content.size},[_c('div',{staticClass:"menu"},[_c('k-form-select',{attrs:{"options":_vm.columns,"reduce":opt => opt.size,"size":"sm","clearable":false},model:{value:(_vm.layout.layout[i].size),callback:function ($$v) {_vm.$set(_vm.layout.layout[i], "size", $$v)},expression:"layout.layout[i].size"}}),(_vm.layout.layout.length > 1)?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"text-danger",attrs:{"size":"sm","variant":"icon","title":_vm.$t('customFields.layout.layoutTitle')},on:{"click":function($event){return _vm.deleteColumn(i)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'times']}})],1):_vm._e()],1),_c('draggable',{staticClass:"fields-draggable",attrs:{"group":"fields"},model:{value:(_vm.layout.layout[i].contents),callback:function ($$v) {_vm.$set(_vm.layout.layout[i], "contents", $$v)},expression:"layout.layout[i].contents"}},_vm._l((_vm.layout.layout[i].contents),function(fieldId){return _c('div',{key:fieldId,staticClass:"field"},[_vm._v(" "+_vm._s(_vm.getCustomField(fieldId).label)+" ")])}),0)],1)}),0)],1)],1)]],2)
}
var DisplayLayoutsFormvue_type_template_id_513d737a_staticRenderFns = []


;// external "vuedraggable"
var external_vuedraggable_namespaceObject = require("vuedraggable");
var external_vuedraggable_default = /*#__PURE__*/__webpack_require__.n(external_vuedraggable_namespaceObject);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/DisplayLayoutsForm/DisplayLayoutsForm.ts?vue&type=script&lang=ts&external








var DisplayLayout = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(DisplayLayout, _super);
    function DisplayLayout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modal = false;
        _this.loading = false;
        _this.layout = {
            force_tab_display: false,
            usages: [],
            layout: []
        };
        _this.columns = [
            { size: 12, label: '1/1', contents: [] },
            { size: 6, label: '1/2', contents: [] },
            { size: 9, label: '3/4', contents: [] },
            { size: 8, label: '2/3', contents: [] },
            { size: 4, label: '1/3', contents: [] },
            { size: 3, label: '1/4', contents: [] }
        ];
        return _this;
    }
    DisplayLayout.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadCustomFields()];
                    case 1:
                        _a.sent();
                        this.watchValue();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    DisplayLayout.prototype.watchValue = function () {
        var _a;
        var _b;
        this.layout = this.value ? JSON.parse(JSON.stringify(this.value)) : {
            usages: [],
            layout: []
        };
        if (this.layout.layout.length === 0) {
            this.layout.layout.push({
                size: 12,
                contents: (_b = this.customFields) === null || _b === void 0 ? void 0 : _b.map(function (field) { return field.id; })
            });
        }
        else {
            var used_1 = [];
            this.layout.layout.forEach(function (layout) { return used_1.push.apply(used_1, layout.contents); });
            var missing = this.customFields
                .map(function (field) { return String(field.id); })
                .filter(function (fiedId) { return !used_1.includes(fiedId); })
                .map(function (id) { return Number(id); });
            (_a = this.layout.layout[this.layout.layout.length - 1].contents).push.apply(_a, missing.map(function (id) { return Number(id); }));
        }
        lib/* Vue */.lD.set(this.layout, 'force_tab_display', false);
    };
    Object.defineProperty(DisplayLayout.prototype, "formAction", {
        get: function () {
            var _a;
            var url = '/config/custom_field/layout';
            if ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) {
                url += '/' + this.value.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplayLayout.prototype, "formMethod", {
        get: function () {
            var _a;
            return ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplayLayout.prototype, "usages", {
        get: function () {
            return this.$kwCustomFields.usages;
        },
        enumerable: false,
        configurable: true
    });
    DisplayLayout.prototype.cloneColumn = function (column) {
        return JSON.parse(JSON.stringify(column));
    };
    DisplayLayout.prototype.deleteColumn = function (index) {
        var _a;
        if (this.layout.layout.length <= 1) {
            return;
        }
        var fields = this.layout.layout[index].contents;
        this.layout.layout.splice(index, 1);
        (_a = this.layout.layout[this.layout.layout.length - 1].contents).push.apply(_a, fields);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], DisplayLayout.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value')
    ], DisplayLayout.prototype, "watchValue", null);
    DisplayLayout = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormCheckboxGroup: form_vue_.KFormCheckboxGroup, KFormCheckbox: form_vue_.KFormCheckbox, KFormSelect: form_vue_.KFormSelect,
                draggable: (external_vuedraggable_default()),
                BButton: external_bootstrap_vue_.BButton, BModal: external_bootstrap_vue_.BModal, BFormGroup: external_bootstrap_vue_.BFormGroup,
                Spinner: interface_vue_.Spinner,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            },
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('customFields', ['customFields'])), (0,external_vuex_.mapGetters)('customFields', ['getCustomField'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('customFields', ['loadCustomFields']))
        })
    ], DisplayLayout);
    return DisplayLayout;
}(lib/* Vue */.lD));
/* harmony default export */ var DisplayLayoutsFormvue_type_script_lang_ts_external = (DisplayLayout);

;// ./src/components/DisplayLayoutsForm/DisplayLayoutsForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var DisplayLayoutsForm_DisplayLayoutsFormvue_type_script_lang_ts_external = (DisplayLayoutsFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/DisplayLayoutsForm/DisplayLayoutsForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  DisplayLayoutsForm_DisplayLayoutsFormvue_type_script_lang_ts_external,
  DisplayLayoutsFormvue_type_template_id_513d737a_render,
  DisplayLayoutsFormvue_type_template_id_513d737a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DisplayLayoutsForm = (component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/DisplayLayouts/DisplayLayouts.ts?vue&type=script&lang=ts&external





var DisplayLayouts = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(DisplayLayouts, _super);
    function DisplayLayouts() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formComponent = DisplayLayoutsForm;
        return _this;
    }
    Object.defineProperty(DisplayLayouts.prototype, "usageLabel", {
        get: function () {
            var _this = this;
            return function (key) { var _a, _b, _c, _d; return (_d = (_c = (_b = (_a = _this.$kwCustomFields) === null || _a === void 0 ? void 0 : _a.usages) === null || _b === void 0 ? void 0 : _b.find(function (usage) { return usage.id === key; })) === null || _c === void 0 ? void 0 : _c.label) !== null && _d !== void 0 ? _d : null; };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplayLayouts.prototype, "columns", {
        get: function () {
            var _this = this;
            return [
                {
                    label: this.$t('customFields.usageLabel'),
                    key: 'usages',
                    show: function (usages) {
                        var _a, _b;
                        return (_b = (_a = usages === null || usages === void 0 ? void 0 : usages.map(function (usage) { return _this.usageLabel(usage); })) === null || _a === void 0 ? void 0 : _a.join(', ')) !== null && _b !== void 0 ? _b : 'Aucune';
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    DisplayLayouts.prototype.submitted = function (layout) {
        this.setLayout(layout);
        this.$refs.list.refresh();
    };
    DisplayLayouts = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('customFields', ['setLayout', 'deleteLayout'])),
            components: {
                DynamicList: interface_vue_.DynamicList
            }
        })
    ], DisplayLayouts);
    return DisplayLayouts;
}(lib/* Vue */.lD));
/* harmony default export */ var DisplayLayoutsvue_type_script_lang_ts_external = (DisplayLayouts);

;// ./src/components/DisplayLayouts/DisplayLayouts.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var DisplayLayouts_DisplayLayoutsvue_type_script_lang_ts_external = (DisplayLayoutsvue_type_script_lang_ts_external); 
;// ./src/components/DisplayLayouts/DisplayLayouts.vue





/* normalize component */
;
var DisplayLayouts_component = (0,componentNormalizer/* default */.A)(
  DisplayLayouts_DisplayLayoutsvue_type_script_lang_ts_external,
  DisplayLayoutsvue_type_template_id_2c96573c_render,
  DisplayLayoutsvue_type_template_id_2c96573c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DisplayLayouts_DisplayLayouts = (DisplayLayouts_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ViewConfiguration/ViewConfiguration.vue?vue&type=template&id=6b59b77c
var ViewConfigurationvue_type_template_id_6b59b77c_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form',{attrs:{"action":_vm.formAction,"method":"PUT"},on:{"submitComplete":_vm.formSubmitted}},[_c('p',{staticClass:"text-justify font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('customFields.viewConfig'))+" ")]),_vm._l((_vm.$kwCustomFields.usages),function(usage){return _c('b-form-group',{key:usage.id,attrs:{"label":usage.label,"label-cols":"3"}},[_c('b-form-radio-group',{staticClass:"mt-2",attrs:{"name":'configs[custom_field_' + usage.id + '_tab]',"options":_vm.options},model:{value:(_vm.localConfig['custom_field_' + usage.id + '_tab']),callback:function ($$v) {_vm.$set(_vm.localConfig, 'custom_field_' + usage.id + '_tab', $$v)},expression:"localConfig['custom_field_' + usage.id + '_tab']"}})],1)}),_c('p',{staticClass:"mt-2"},[_vm._v(" ")]),_c('k-form-sticky-bar',{attrs:{"parent":"#page"}},[_c('b-button',{staticClass:"mr-2",attrs:{"variant":"secondary"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('interface.cancel'))+" ")]),_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v(" "+_vm._s(_vm.$t('interface.save'))+" ")])],1)],2)
}
var ViewConfigurationvue_type_template_id_6b59b77c_staticRenderFns = []


;// ./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ViewConfiguration/ViewConfiguration.ts?vue&type=script&lang=js&external





var ViewConfiguration = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ViewConfiguration, _super);
    function ViewConfiguration() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ViewConfiguration.prototype, "options", {
        get: function () {
            return [
                { value: true, text: this.$t('interface.yes') },
                { value: false, text: this.$t('interface.no') }
            ];
        },
        enumerable: false,
        configurable: true
    });
    ViewConfiguration = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormStickyBar: form_vue_.KFormStickyBar,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BButton: external_bootstrap_vue_.BButton
            }
        })
    ], ViewConfiguration);
    return ViewConfiguration;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin)));
/* harmony default export */ var ViewConfigurationvue_type_script_lang_js_external = (ViewConfiguration);

;// ./src/components/ViewConfiguration/ViewConfiguration.ts?vue&type=script&lang=js&external
 /* harmony default export */ var ViewConfiguration_ViewConfigurationvue_type_script_lang_js_external = (ViewConfigurationvue_type_script_lang_js_external); 
;// ./src/components/ViewConfiguration/ViewConfiguration.vue





/* normalize component */
;
var ViewConfiguration_component = (0,componentNormalizer/* default */.A)(
  ViewConfiguration_ViewConfigurationvue_type_script_lang_js_external,
  ViewConfigurationvue_type_template_id_6b59b77c_render,
  ViewConfigurationvue_type_template_id_6b59b77c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ViewConfiguration_ViewConfiguration = (ViewConfiguration_component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CustomFieldsView.vue?vue&type=script&lang=ts






var CustomFieldsView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomFieldsView, _super);
    function CustomFieldsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomFieldsView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CustomFields: CustomFields/* default */.A,
                DisplayLayouts: DisplayLayouts_DisplayLayouts,
                ViewConfiguration: ViewConfiguration_ViewConfiguration,
                BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab
            }
        })
    ], CustomFieldsView);
    return CustomFieldsView;
}(lib/* Vue */.lD));
/* harmony default export */ var CustomFieldsViewvue_type_script_lang_ts = (CustomFieldsView);

;// ./src/views/CustomFieldsView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_CustomFieldsViewvue_type_script_lang_ts = (CustomFieldsViewvue_type_script_lang_ts); 
;// ./src/views/CustomFieldsView.vue





/* normalize component */
;
var CustomFieldsView_component = (0,componentNormalizer/* default */.A)(
  views_CustomFieldsViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_CustomFieldsView = (CustomFieldsView_component.exports);

/***/ }),

/***/ 1656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ normalizeComponent; }
/* harmony export */ });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 1873:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(9325);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 3729:
/***/ (function(module) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ 695:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(8096),
    isArguments = __webpack_require__(2428),
    isArray = __webpack_require__(6449),
    isBuffer = __webpack_require__(3656),
    isIndex = __webpack_require__(361),
    isTypedArray = __webpack_require__(7167);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 909:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseForOwn = __webpack_require__(641),
    createBaseEach = __webpack_require__(8329);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ 6649:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createBaseFor = __webpack_require__(3221);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ 641:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFor = __webpack_require__(6649),
    keys = __webpack_require__(5950);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ 2552:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(1873),
    getRawTag = __webpack_require__(659),
    objectToString = __webpack_require__(9350);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 7534:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 4901:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isLength = __webpack_require__(294),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 8984:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(5527),
    nativeKeys = __webpack_require__(3650);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 8096:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 7301:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 4066:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(3488);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),

/***/ 8329:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(4894);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ 3221:
/***/ (function(module) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 4840:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 659:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(1873);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 361:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 5527:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 3650:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(4335);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 6009:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(4840);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 9350:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 4335:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 9325:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(4840);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 9754:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayEach = __webpack_require__(3729),
    baseEach = __webpack_require__(909),
    castFunction = __webpack_require__(4066),
    isArray = __webpack_require__(6449);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),

/***/ 3488:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 2428:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(7534),
    isObjectLike = __webpack_require__(346);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 6449:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 4894:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(1882),
    isLength = __webpack_require__(294);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 3656:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(9325),
    stubFalse = __webpack_require__(9935);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 1882:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isObject = __webpack_require__(3805);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 294:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 3805:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 346:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 7167:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(4901),
    baseUnary = __webpack_require__(7301),
    nodeUtil = __webpack_require__(6009);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 5950:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(695),
    baseKeys = __webpack_require__(8984),
    isArrayLike = __webpack_require__(4894);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 9935:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 1848:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

;// external "@fortawesome/fontawesome-svg-core"
var fontawesome_svg_core_namespaceObject = require("@fortawesome/fontawesome-svg-core");
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faTimes.js
var faTimes = __webpack_require__(2986);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faSlidersVSquare.js
var faSlidersVSquare = __webpack_require__(6041);
;// ./src/fontawesome.ts



fontawesome_svg_core_namespaceObject.library.add(faTimes/* faTimes */.GR, faSlidersVSquare/* faSlidersVSquare */.TA);


/***/ }),

/***/ 7504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1635);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9603);
/* harmony import */ var _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2652);
/* harmony import */ var _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1__);



var CustomFieldsMixin = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__extends */ .C6)(CustomFieldsMixin, _super);
    function CustomFieldsMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CustomFieldsMixin.prototype, "types", {
        get: function () {
            return [
                { id: 'text', label: this.$t('customFields.types.text') },
                { id: 'textarea', label: this.$t('customFields.types.textarea') },
                { id: 'rich-editor', label: this.$t('customFields.types.rich-editor') },
                { id: 'date', label: this.$t('customFields.types.date') },
                { id: 'phone', label: this.$t('customFields.types.phone') },
                { id: 'amount', label: this.$t('customFields.types.amount') },
                { id: 'number', label: this.$t('customFields.types.number') },
                { id: 'quantity', label: this.$t('customFields.types.quantity') },
                { id: 'checkbox', label: this.$t('customFields.types.checkbox'), withOptions: true },
                { id: 'radio', label: this.$t('customFields.types.radio'), withOptions: true },
                { id: 'select', label: this.$t('customFields.types.select'), withOptions: true }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomFieldsMixin.prototype, "defaultTypes", {
        get: function () {
            return this.types.map(function (type) { return type.id; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomFieldsMixin.prototype, "custom", {
        get: function () {
            var _this = this;
            return function (type) { var _a, _b; return (_b = (_a = _this.$kwCustomFields.fields) === null || _a === void 0 ? void 0 : _a.find(function (field) { return field.type === type; })) !== null && _b !== void 0 ? _b : []; };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomFieldsMixin.prototype, "usages", {
        get: function () {
            return this.$kwCustomFields.usages;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomFieldsMixin.prototype, "usage", {
        get: function () {
            var _this = this;
            return function (key) { var _a, _b; return (_b = (_a = _this.$kwCustomFields.usages) === null || _a === void 0 ? void 0 : _a.find(function (usage) { return usage.id === key; })) !== null && _b !== void 0 ? _b : []; };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomFieldsMixin.prototype, "getFieldValue", {
        get: function () {
            var _this = this;
            return function (field, value, currency) {
                if (value === undefined || value === null) {
                    return null;
                }
                else if (value === '') {
                    return '';
                }
                if (!_this.defaultTypes.includes(field.type)) {
                    return _this.custom(field.type).view(value);
                }
                switch (field.type) {
                    case 'number':
                    case 'quantity':
                        return _this.showNumber(value);
                    case 'amount':
                        return _this.showNumber(value) + (currency ? ' ' + currency.symbol : '');
                    case 'date':
                        return _this.date(value);
                    case 'checkbox':
                        return value.map(function (val) { return val.label; }).join(', ');
                    case 'select':
                    case 'radio':
                        return value.label;
                    case 'phone':
                        return _this.showPhone(value);
                    default:
                        return value;
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomFieldsMixin.prototype, "getFieldLink", {
        get: function () {
            var _this = this;
            return function (field, value) {
                if (value === undefined || value === null) {
                    return null;
                }
                else if (value === '') {
                    return null;
                }
                if (_this.defaultTypes.includes(field.type)) {
                    return null;
                }
                var customField = _this.custom(field.type);
                if (customField && customField.viewLink) {
                    return customField.viewLink(value);
                }
                return null;
            };
        },
        enumerable: false,
        configurable: true
    });
    CustomFieldsMixin = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__decorate */ .Cg)([
        vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .uA
    ], CustomFieldsMixin);
    return CustomFieldsMixin;
}((0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Mixins */ .Xe)(_kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1__.NumberMixin, _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1__.DateMixin, _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_1__.PhoneMixin)));
/* harmony default export */ __webpack_exports__.A = (CustomFieldsMixin);


/***/ }),

/***/ 9603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  uA: function() { return /* reexport */ vue_class_component_esm; },
  O5: function() { return /* reexport */ Emit; },
  Xe: function() { return /* reexport */ mixins; },
  kv: function() { return /* reexport */ Prop; },
  lD: function() { return /* reexport */ (external_vue_default()); },
  ox: function() { return /* reexport */ Watch; }
});

// UNUSED EXPORTS: Inject, InjectReactive, Model, ModelSync, PropSync, Provide, ProvideReactive, Ref, VModel

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
;// ./node_modules/vue-class-component/dist/vue-class-component.esm.js
/**
  * vue-class-component v7.2.6
  * (c) 2015-present Evan You
  * @license MIT
  */


function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

// The rational behind the verbose Reflect-feature check below is the fact that there are polyfills
// which add an implementation for Reflect.defineMetadata but not for Reflect.getOwnMetadataKeys.
// Without this check consumers will encounter hard to track down runtime errors.
function reflectionIsSupported() {
  return typeof Reflect !== 'undefined' && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;
}
function copyReflectionMetadata(to, from) {
  forwardMetadata(to, from);
  Object.getOwnPropertyNames(from.prototype).forEach(function (key) {
    forwardMetadata(to.prototype, from.prototype, key);
  });
  Object.getOwnPropertyNames(from).forEach(function (key) {
    forwardMetadata(to, from, key);
  });
}

function forwardMetadata(to, from, propertyKey) {
  var metaKeys = propertyKey ? Reflect.getOwnMetadataKeys(from, propertyKey) : Reflect.getOwnMetadataKeys(from);
  metaKeys.forEach(function (metaKey) {
    var metadata = propertyKey ? Reflect.getOwnMetadata(metaKey, from, propertyKey) : Reflect.getOwnMetadata(metaKey, from);

    if (propertyKey) {
      Reflect.defineMetadata(metaKey, metadata, to, propertyKey);
    } else {
      Reflect.defineMetadata(metaKey, metadata, to);
    }
  });
}

var fakeArray = {
  __proto__: []
};
var hasProto = fakeArray instanceof Array;
function vue_class_component_esm_createDecorator(factory) {
  return function (target, key, index) {
    var Ctor = typeof target === 'function' ? target : target.constructor;

    if (!Ctor.__decorators__) {
      Ctor.__decorators__ = [];
    }

    if (typeof index !== 'number') {
      index = undefined;
    }

    Ctor.__decorators__.push(function (options) {
      return factory(options, key, index);
    });
  };
}
function mixins() {
  for (var _len = arguments.length, Ctors = new Array(_len), _key = 0; _key < _len; _key++) {
    Ctors[_key] = arguments[_key];
  }

  return external_vue_default().extend({
    mixins: Ctors
  });
}
function isPrimitive(value) {
  var type = _typeof(value);

  return value == null || type !== 'object' && type !== 'function';
}
function warn(message) {
  if (typeof console !== 'undefined') {
    console.warn('[vue-class-component] ' + message);
  }
}

function collectDataFromConstructor(vm, Component) {
  // override _init to prevent to init as Vue instance
  var originalInit = Component.prototype._init;

  Component.prototype._init = function () {
    var _this = this;

    // proxy to actual vm
    var keys = Object.getOwnPropertyNames(vm); // 2.2.0 compat (props are no longer exposed as self properties)

    if (vm.$options.props) {
      for (var key in vm.$options.props) {
        if (!vm.hasOwnProperty(key)) {
          keys.push(key);
        }
      }
    }

    keys.forEach(function (key) {
      Object.defineProperty(_this, key, {
        get: function get() {
          return vm[key];
        },
        set: function set(value) {
          vm[key] = value;
        },
        configurable: true
      });
    });
  }; // should be acquired class property values


  var data = new Component(); // restore original _init to avoid memory leak (#209)

  Component.prototype._init = originalInit; // create plain data object

  var plainData = {};
  Object.keys(data).forEach(function (key) {
    if (data[key] !== undefined) {
      plainData[key] = data[key];
    }
  });

  if (false) {}

  return plainData;
}

var $internalHooks = ['data', 'beforeCreate', 'created', 'beforeMount', 'mounted', 'beforeDestroy', 'destroyed', 'beforeUpdate', 'updated', 'activated', 'deactivated', 'render', 'errorCaptured', 'serverPrefetch' // 2.6
];
function componentFactory(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  options.name = options.name || Component._componentTag || Component.name; // prototype props.

  var proto = Component.prototype;
  Object.getOwnPropertyNames(proto).forEach(function (key) {
    if (key === 'constructor') {
      return;
    } // hooks


    if ($internalHooks.indexOf(key) > -1) {
      options[key] = proto[key];
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(proto, key);

    if (descriptor.value !== void 0) {
      // methods
      if (typeof descriptor.value === 'function') {
        (options.methods || (options.methods = {}))[key] = descriptor.value;
      } else {
        // typescript decorated data
        (options.mixins || (options.mixins = [])).push({
          data: function data() {
            return _defineProperty({}, key, descriptor.value);
          }
        });
      }
    } else if (descriptor.get || descriptor.set) {
      // computed properties
      (options.computed || (options.computed = {}))[key] = {
        get: descriptor.get,
        set: descriptor.set
      };
    }
  });
  (options.mixins || (options.mixins = [])).push({
    data: function data() {
      return collectDataFromConstructor(this, Component);
    }
  }); // decorate options

  var decorators = Component.__decorators__;

  if (decorators) {
    decorators.forEach(function (fn) {
      return fn(options);
    });
    delete Component.__decorators__;
  } // find super


  var superProto = Object.getPrototypeOf(Component.prototype);
  var Super = superProto instanceof (external_vue_default()) ? superProto.constructor : (external_vue_default());
  var Extended = Super.extend(options);
  forwardStaticMembers(Extended, Component, Super);

  if (reflectionIsSupported()) {
    copyReflectionMetadata(Extended, Component);
  }

  return Extended;
}
var reservedPropertyNames = (/* unused pure expression or super */ null && ([// Unique id
'cid', // Super Vue constructor
'super', // Component options that will be used by the component
'options', 'superOptions', 'extendOptions', 'sealedOptions', // Private assets
'component', 'directive', 'filter']));
var shouldIgnore = {
  prototype: true,
  arguments: true,
  callee: true,
  caller: true
};

function forwardStaticMembers(Extended, Original, Super) {
  // We have to use getOwnPropertyNames since Babel registers methods as non-enumerable
  Object.getOwnPropertyNames(Original).forEach(function (key) {
    // Skip the properties that should not be overwritten
    if (shouldIgnore[key]) {
      return;
    } // Some browsers does not allow reconfigure built-in properties


    var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);

    if (extendedDescriptor && !extendedDescriptor.configurable) {
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(Original, key); // If the user agent does not support `__proto__` or its family (IE <= 10),
    // the sub class properties may be inherited properties from the super class in TypeScript.
    // We need to exclude such properties to prevent to overwrite
    // the component options object which stored on the extended constructor (See #192).
    // If the value is a referenced value (object or function),
    // we can check equality of them and exclude it if they have the same reference.
    // If it is a primitive value, it will be forwarded for safety.

    if (!hasProto) {
      // Only `cid` is explicitly exluded from property forwarding
      // because we cannot detect whether it is a inherited property or not
      // on the no `__proto__` environment even though the property is reserved.
      if (key === 'cid') {
        return;
      }

      var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);

      if (!isPrimitive(descriptor.value) && superDescriptor && superDescriptor.value === descriptor.value) {
        return;
      }
    } // Warn if the users manually declare reserved properties


    if (false) {}

    Object.defineProperty(Extended, key, descriptor);
  });
}

function Component(options) {
  if (typeof options === 'function') {
    return componentFactory(options);
  }

  return function (Component) {
    return componentFactory(Component, options);
  };
}

Component.registerHooks = function registerHooks(keys) {
  $internalHooks.push.apply($internalHooks, _toConsumableArray(keys));
};

/* harmony default export */ var vue_class_component_esm = (Component);


;// ./node_modules/vue-property-decorator/lib/decorators/Emit.js
var __spreadArrays = (undefined && undefined.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
// Code copied from Vue/src/shared/util.js
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = function (str) { return str.replace(hyphenateRE, '-$1').toLowerCase(); };
/**
 * decorator of an event-emitter function
 * @param  event The name of the event
 * @return MethodDecorator
 */
function Emit(event) {
    return function (_target, propertyKey, descriptor) {
        var key = hyphenate(propertyKey);
        var original = descriptor.value;
        descriptor.value = function emitter() {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var emit = function (returnValue) {
                var emitName = event || key;
                if (returnValue === undefined) {
                    if (args.length === 0) {
                        _this.$emit(emitName);
                    }
                    else if (args.length === 1) {
                        _this.$emit(emitName, args[0]);
                    }
                    else {
                        _this.$emit.apply(_this, __spreadArrays([emitName], args));
                    }
                }
                else {
                    args.unshift(returnValue);
                    _this.$emit.apply(_this, __spreadArrays([emitName], args));
                }
            };
            var returnValue = original.apply(this, args);
            if (isPromise(returnValue)) {
                returnValue.then(emit);
            }
            else {
                emit(returnValue);
            }
            return returnValue;
        };
    };
}
function isPromise(obj) {
    return obj instanceof Promise || (obj && typeof obj.then === 'function');
}

;// ./node_modules/vue-property-decorator/lib/helpers/metadata.js
/** @see {@link https://github.com/vuejs/vue-class-component/blob/master/src/reflect.ts} */
var reflectMetadataIsSupported = typeof Reflect !== 'undefined' && typeof Reflect.getMetadata !== 'undefined';
function metadata_applyMetadata(options, target, key) {
    if (reflectMetadataIsSupported) {
        if (!Array.isArray(options) &&
            typeof options !== 'function' &&
            !options.hasOwnProperty('type') &&
            typeof options.type === 'undefined') {
            var type = Reflect.getMetadata('design:type', target, key);
            if (type !== Object) {
                options.type = type;
            }
        }
    }
}

;// ./node_modules/vue-property-decorator/lib/decorators/Model.js


/**
 * decorator of model
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function Model(event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
            componentOptions.model = { prop: k, event: event || k };
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/ModelSync.js


/**
 * decorator of synced model and prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function ModelSync(propName, event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            componentOptions.model = { prop: propName, event: event || k };
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                get: function () {
                    return this[propName];
                },
                set: function (value) {
                    // @ts-ignore
                    this.$emit(event, value);
                },
            };
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/Prop.js


/**
 * decorator of a prop
 * @param  options the options for the prop
 * @return PropertyDecorator | void
 */
function Prop(options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        metadata_applyMetadata(options, target, key);
        vue_class_component_esm_createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/PropSync.js


/**
 * decorator of a synced prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param options the options for the synced prop
 * @return PropertyDecorator | void
 */
function PropSync(propName, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                get: function () {
                    return this[propName];
                },
                set: function (value) {
                    this.$emit("update:" + propName, value);
                },
            };
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/Watch.js

/**
 * decorator of a watch function
 * @param  path the path or the expression to observe
 * @param  WatchOption
 * @return MethodDecorator
 */
function Watch(path, options) {
    if (options === void 0) { options = {}; }
    var _a = options.deep, deep = _a === void 0 ? false : _a, _b = options.immediate, immediate = _b === void 0 ? false : _b;
    return vue_class_component_esm_createDecorator(function (componentOptions, handler) {
        if (typeof componentOptions.watch !== 'object') {
            componentOptions.watch = Object.create(null);
        }
        var watch = componentOptions.watch;
        if (typeof watch[path] === 'object' && !Array.isArray(watch[path])) {
            watch[path] = [watch[path]];
        }
        else if (typeof watch[path] === 'undefined') {
            watch[path] = [];
        }
        watch[path].push({ handler: handler, deep: deep, immediate: immediate });
    });
}

;// ./node_modules/vue-property-decorator/lib/index.js
/** vue-property-decorator verson 9.1.2 MIT LICENSE copyright 2020 kaorun343 */
/// <reference types='reflect-metadata'/>

















/***/ }),

/***/ 9356:
/***/ (function(module) {

"use strict";
module.exports = require("@fortawesome/vue-fontawesome");

/***/ }),

/***/ 8057:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/form-vue");

/***/ }),

/***/ 2652:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/interface-vue");

/***/ }),

/***/ 9529:
/***/ (function(module) {

"use strict";
module.exports = require("bootstrap-vue");

/***/ }),

/***/ 622:
/***/ (function(module) {

"use strict";
module.exports = require("vue");

/***/ }),

/***/ 9998:
/***/ (function(module) {

"use strict";
module.exports = require("vuex");

/***/ }),

/***/ 1635:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C6: function() { return /* binding */ __extends; },
/* harmony export */   Cg: function() { return /* binding */ __decorate; },
/* harmony export */   Cl: function() { return /* binding */ __assign; },
/* harmony export */   YH: function() { return /* binding */ __generator; },
/* harmony export */   sH: function() { return /* binding */ __awaiter; }
/* harmony export */ });
/* unused harmony exports __rest, __param, __esDecorate, __runInitializers, __propKey, __setFunctionName, __metadata, __createBinding, __exportStar, __values, __read, __spread, __spreadArrays, __spreadArray, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet, __classPrivateFieldIn, __addDisposableResource, __disposeResources */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  }
  return __assign.apply(this, arguments);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
  function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
  function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose, inner;
    if (async) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      dispose = value[Symbol.dispose];
      if (async) inner = dispose;
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
    env.stack.push({ value: value, dispose: dispose, async: async });
  }
  else if (async) {
    env.stack.push({ async: true });
  }
  return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  var r, s = 0;
  function next() {
    while (r = env.stack.pop()) {
      try {
        if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
        if (r.dispose) {
          var result = r.dispose.call(r.value);
          if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
        }
        else s |= 1;
      }
      catch (e) {
        fail(e);
      }
    }
    if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
    if (env.hasError) throw env.error;
  }
  return next();
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
});


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	!function() {
/******/ 		__webpack_require__.nmd = function(module) {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  CustomFieldForm: function() { return /* reexport */ CustomFieldForm/* default */.A; },
  CustomFields: function() { return /* reexport */ CustomFields/* default */.A; },
  CustomFieldsDisplay: function() { return /* reexport */ CustomFieldsDisplay_CustomFieldsDisplay; },
  CustomFieldsDisplayTab: function() { return /* reexport */ CustomFieldsDisplayTab_CustomFieldsDisplayTab; },
  CustomFieldsForm: function() { return /* reexport */ CustomFieldsForm_CustomFieldsForm; },
  CustomFieldsMixin: function() { return /* reexport */ CustomFieldsMixin/* default */.A; },
  CustomFieldsStore: function() { return /* reexport */ modules_CustomFieldsStore; },
  CustomFieldsTableMixin: function() { return /* reexport */ mixins_CustomFieldsTableMixin; },
  CustomFieldsView: function() { return /* reexport */ CustomFieldsView["default"]; },
  KwixeoCustomFields: function() { return /* reexport */ install; },
  Lang: function() { return /* reexport */ lang; },
  configMenu: function() { return /* reexport */ configs; },
  configRoutes: function() { return /* reexport */ configRoutes; }
});

;// ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./src/components/CustomFieldForm/CustomFieldForm.vue + 3 modules
var CustomFieldForm = __webpack_require__(5071);
// EXTERNAL MODULE: ./src/components/CustomFields/CustomFields.vue + 3 modules
var CustomFields = __webpack_require__(9537);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomFieldsDisplay/CustomFieldsDisplay.vue?vue&type=template&id=1e2467f2
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.withTitle && _vm.hasValues)?_c('h3',{class:_vm.titleClass},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'sliders-v-square']}}),_vm._v(" "+_vm._s(_vm.$t('customFields.formTitle'))+" ")],1):_vm._e(),_vm._l((_vm.fields),function(field){return [(_vm.getValue(field.id) !== null || _vm.showEmpty !== false)?_c('b-form-group',_vm._b({key:field.id,attrs:{"label":field.label}},'b-form-group',_vm.formGroupProperties,false),[(_vm.getValue(field.id) === null)?[_vm._v(" "+_vm._s(_vm.emptyText)+" ")]:(field.type === 'textarea')?_c('TextareaView',{attrs:{"value":_vm.getValue(field.id)}}):(field.type === 'rich-editor')?_c('FroalaView',{attrs:{"value":_vm.getValue(field.id)}}):[(_vm.getValueLink(field.id))?_c('router-link',{attrs:{"to":_vm.getValueLink(field.id)}},[_vm._v(" "+_vm._s(_vm.getValue(field.id))+" ")]):[_vm._v(" "+_vm._s(_vm.getValue(field.id))+" ")]]],2):_vm._e()]})],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: ./src/mixins/CustomFieldsMixin.ts
var CustomFieldsMixin = __webpack_require__(7504);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomFieldsDisplay/CustomFieldsDisplay.ts?vue&type=script&lang=ts&external








var CustomFieldsDisplay = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomFieldsDisplay, _super);
    function CustomFieldsDisplay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        return _this;
    }
    CustomFieldsDisplay.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadCustomFields()];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CustomFieldsDisplay.prototype, "formGroupProperties", {
        get: function () {
            return (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({ class: this.formGroupClass }, (0,interface_vue_.applyProps)('content-cols', this.$props)), (0,interface_vue_.applyProps)('label-cols', this.$props)), (0,interface_vue_.applyProps)('label-align', this.$props));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomFieldsDisplay.prototype, "hasValues", {
        get: function () {
            return this.fields.length > 0 && this.value.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomFieldsDisplay.prototype, "computedCurrency", {
        get: function () {
            var _a;
            return (_a = this.localCurrency) !== null && _a !== void 0 ? _a : this.currency;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomFieldsDisplay.prototype, "fields", {
        // Return fields for type
        get: function () {
            return this.getCustomFields(this.type);
        },
        enumerable: false,
        configurable: true
    });
    CustomFieldsDisplay.prototype.getValue = function (id) {
        var _a;
        var field = this.fields.find(function (field) { return field.id === id; });
        if (!field) {
            return null;
        }
        var value = this.value && ((_a = this.value.find(function (val) { return val.id === id; })) === null || _a === void 0 ? void 0 : _a.value);
        return this.getFieldValue(field, value, this.computedCurrency);
    };
    CustomFieldsDisplay.prototype.getValueLink = function (id) {
        var _a;
        var field = this.fields.find(function (field) { return field.id === id; });
        if (!field) {
            return null;
        }
        var value = this.value && ((_a = this.value.find(function (val) { return val.id === id; })) === null || _a === void 0 ? void 0 : _a.value);
        return this.getFieldLink(field, value);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomFieldsDisplay.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return []; } })
    ], CustomFieldsDisplay.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], CustomFieldsDisplay.prototype, "withTitle", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'form-title' })
    ], CustomFieldsDisplay.prototype, "titleClass", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomFieldsDisplay.prototype, "formGroupClass", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomFieldsDisplay.prototype, "localCurrency", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CustomFieldsDisplay.prototype, "showEmpty", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: '-' })
    ], CustomFieldsDisplay.prototype, "emptyText", void 0);
    CustomFieldsDisplay = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('customFields', ['getCustomFields'])), (0,external_vuex_.mapGetters)('user', ['currency'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('customFields', ['loadCustomFields'])),
            components: {
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                FroalaView: form_vue_.FroalaView,
                BFormGroup: external_bootstrap_vue_.BFormGroup,
                TextareaView: interface_vue_.TextareaView
            },
            props: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,interface_vue_.generateProps)('content-cols', null, (0,interface_vue_.getBreakpoints)())), (0,interface_vue_.generateProps)('label-cols', null, (0,interface_vue_.getBreakpoints)())), (0,interface_vue_.generateProps)('label-align', null, (0,interface_vue_.getBreakpoints)()))
        })
    ], CustomFieldsDisplay);
    return CustomFieldsDisplay;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin, interface_vue_.DateMixin, CustomFieldsMixin/* default */.A)));
/* harmony default export */ var CustomFieldsDisplayvue_type_script_lang_ts_external = (CustomFieldsDisplay);

;// ./src/components/CustomFieldsDisplay/CustomFieldsDisplay.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomFieldsDisplay_CustomFieldsDisplayvue_type_script_lang_ts_external = (CustomFieldsDisplayvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CustomFieldsDisplay/CustomFieldsDisplay.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomFieldsDisplay_CustomFieldsDisplayvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomFieldsDisplay_CustomFieldsDisplay = (component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomFieldsDisplayTab/CustomFieldsDisplayTab.vue?vue&type=template&id=5b3a7a78
var CustomFieldsDisplayTabvue_type_template_id_5b3a7a78_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,{tag:"component",attrs:{"title":_vm.$t('customFields.menu')}},[(!_vm.edit)?[(_vm.canUpdate)?_c('b-button',{staticClass:"mb-3",attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.edit = true}}},[_vm._v(" "+_vm._s(_vm.$t('interface.edit'))+" ")]):_vm._e(),_c('b-row',_vm._l((_vm.layout),function(column,k){return _c('b-col',{key:k,attrs:{"cols":column.size}},[_vm._l((column.contents),function(field){return [(_vm.getValue(field.id) !== null || _vm.showEmpty !== false)?_c('b-form-group',_vm._b({key:field.id,attrs:{"label":field.label}},'b-form-group',_vm.formGroupProperties,false),[(_vm.getValue(field.id) === null)?[_vm._v(" "+_vm._s(_vm.emptyText)+" ")]:(field.type === 'rich-editor')?_c('FroalaView',{attrs:{"value":_vm.getValue(field.id)}}):[(_vm.getValueLink(field.id))?_c('router-link',{attrs:{"to":_vm.getValueLink(field.id)}},[_vm._v(" "+_vm._s(_vm.getValue(field.id))+" ")]):[_vm._v(" "+_vm._s(_vm.getValue(field.id))+" ")]]],2):_vm._e()]})],2)}),1)]:[_c('k-form',{attrs:{"action":_vm.formUrl,"method":"PUT"},on:{"submitComplete":_vm.submitComplete}},[_c('CustomFieldsForm',{attrs:{"type":_vm.type,"value":_vm.value,"withTitle":false,"filter":_vm.filter}}),_c('k-form-sticky-bar',[_c('b-button',{staticClass:"mr-2",attrs:{"variant":"secondary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.cancelForm.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('interface.cancel'))+" ")]),_c('b-button',{attrs:{"type":"submit","variant":"primary","size":"sm"}},[_vm._v(" "+_vm._s(_vm.$t('interface.save'))+" ")])],1)],1)]],2)
}
var CustomFieldsDisplayTabvue_type_template_id_5b3a7a78_staticRenderFns = []


;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomFieldsForm/CustomFieldsForm.vue?vue&type=template&id=dec1f804
var CustomFieldsFormvue_type_template_id_dec1f804_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):[(_vm.withTitle && _vm.fields.length > 0)?_c('h3',{class:_vm.titleClass},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'sliders-v-square']}}),_vm._v(" "+_vm._s(_vm.$t('customFields.formTitle'))+" ")],1):_vm._e(),_c('b-row',_vm._l((_vm.layout),function(column,k){return _c('b-col',{key:k,attrs:{"cols":column.size}},_vm._l((_vm.filterFields(column.contents)),function(field,i){return _c('b-form-group',{key:field.id,attrs:{"label":field.label}},[(_vm.name !== null)?_c('input',{attrs:{"type":"hidden","name":_vm.name + '[' + k + i + '][id]'},domProps:{"value":field.id}}):_vm._e(),(field.type === 'amount')?_c('b-input-group',{attrs:{"append":_vm.currency ? _vm.currency.symbol : null}},[_c('k-form-number',_vm._b({attrs:{"noDefaultValue":"","name":_vm.fieldName(field, k + '' + i)},on:{"input":_vm.emitValues},model:{value:(_vm.values[field.id]),callback:function ($$v) {_vm.$set(_vm.values, field.id, $$v)},expression:"values[field.id]"}},'k-form-number',_vm.getAttributes(field),false))],1):(field.type === 'number')?_c('k-form-number',_vm._b({attrs:{"noDefaultValue":"","name":_vm.fieldName(field, k + '' + i)},on:{"input":_vm.emitValues},model:{value:(_vm.values[field.id]),callback:function ($$v) {_vm.$set(_vm.values, field.id, $$v)},expression:"values[field.id]"}},'k-form-number',_vm.getAttributes(field),false)):(field.type === 'quantity')?_c('k-form-number',_vm._b({attrs:{"noDefaultValue":"","name":_vm.fieldName(field, k + '' + i)},on:{"input":_vm.emitValues},model:{value:(_vm.values[field.id]),callback:function ($$v) {_vm.$set(_vm.values, field.id, $$v)},expression:"values[field.id]"}},'k-form-number',_vm.getAttributes(field),false)):(field.type === 'text')?_c('k-form-input',_vm._b({attrs:{"name":_vm.fieldName(field, k + '' + i)},on:{"input":_vm.emitValues},model:{value:(_vm.values[field.id]),callback:function ($$v) {_vm.$set(_vm.values, field.id, $$v)},expression:"values[field.id]"}},'k-form-input',_vm.getAttributes(field),false)):(field.type === 'textarea')?_c('k-form-textarea',_vm._b({attrs:{"name":_vm.fieldName(field, k + '' + i)},on:{"input":_vm.emitValues},model:{value:(_vm.values[field.id]),callback:function ($$v) {_vm.$set(_vm.values, field.id, $$v)},expression:"values[field.id]"}},'k-form-textarea',_vm.getAttributes(field),false)):(field.type === 'phone')?_c('k-form-phone',_vm._b({attrs:{"name":_vm.fieldName(field, k + '' + i)},on:{"input":_vm.emitValues},model:{value:(_vm.values[field.id]),callback:function ($$v) {_vm.$set(_vm.values, field.id, $$v)},expression:"values[field.id]"}},'k-form-phone',_vm.getAttributes(field),false)):(field.type === 'date')?_c('k-form-datepicker',_vm._b({attrs:{"name":_vm.fieldName(field, k + '' + i)},on:{"input":_vm.emitValues},model:{value:(_vm.values[field.id]),callback:function ($$v) {_vm.$set(_vm.values, field.id, $$v)},expression:"values[field.id]"}},'k-form-datepicker',_vm.getAttributes(field),false)):(field.type === 'rich-editor')?_c('k-form-editor',_vm._b({attrs:{"name":_vm.fieldName(field, k + '' + i),"size":"sm"},on:{"input":_vm.emitValues},model:{value:(_vm.values[field.id]),callback:function ($$v) {_vm.$set(_vm.values, field.id, $$v)},expression:"values[field.id]"}},'k-form-editor',_vm.getAttributes(field),false)):(field.type === 'checkbox')?[_vm._l((_vm.values[field.id]),function(value,j){return _c('input',{key:'checkbox-' + i + '-' + j,attrs:{"type":"hidden","name":_vm.fieldName(field, k + '' + i)},domProps:{"value":value.label}})}),(!_vm.values[field.id] || _vm.values[field.id].length === 0)?_c('input',{attrs:{"type":"hidden","name":_vm.fieldName(field, k + '' + i)},domProps:{"value":null}}):_vm._e(),_c('k-form-checkbox-group',_vm._b({on:{"input":_vm.emitValues},model:{value:(_vm.values[field.id]),callback:function ($$v) {_vm.$set(_vm.values, field.id, $$v)},expression:"values[field.id]"}},'k-form-checkbox-group',_vm.getAttributes(field),false),_vm._l((field.options),function(option){return _c('k-form-checkbox',{key:option.id,attrs:{"value":option}},[_vm._v(" "+_vm._s(option.label)+" ")])}),1)]:(field.type === 'radio')?[_c('input',{attrs:{"type":"hidden","name":_vm.fieldName(field, k + '' + i)},domProps:{"value":_vm.values[field.id] ? _vm.values[field.id].label : null}}),_c('b-form-radio-group',_vm._b({model:{value:(_vm.values[field.id]),callback:function ($$v) {_vm.$set(_vm.values, field.id, $$v)},expression:"values[field.id]"}},'b-form-radio-group',_vm.getAttributes(field),false),_vm._l((field.options),function(option){return _c('b-form-radio',{key:option.id,attrs:{"value":option},on:{"input":_vm.emitValues}},[_vm._v(" "+_vm._s(option.label)+" ")])}),1)]:(field.type === 'select')?[_c('input',{attrs:{"type":"hidden","name":_vm.fieldName(field, k + '' + i)},domProps:{"value":_vm.values[field.id] ? _vm.values[field.id].label : null}}),_c('k-form-select',_vm._b({attrs:{"options":field.options},on:{"input":_vm.emitValues},model:{value:(_vm.values[field.id]),callback:function ($$v) {_vm.$set(_vm.values, field.id, $$v)},expression:"values[field.id]"}},'k-form-select',_vm.getAttributes(field),false))]:[_c('input',{attrs:{"type":"hidden","name":_vm.fieldName(field, k + '' + i)},domProps:{"value":_vm.reduceValue(field, _vm.values[field.id])}}),_c('k-form-select',_vm._b({on:{"input":_vm.emitValues},model:{value:(_vm.values[field.id]),callback:function ($$v) {_vm.$set(_vm.values, field.id, $$v)},expression:"values[field.id]"}},'k-form-select',_vm.getAttributes(field),false))]],2)}),1)}),1)]],2)
}
var CustomFieldsFormvue_type_template_id_dec1f804_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomFieldsForm/CustomFieldsForm.ts?vue&type=script&lang=ts&external








var CustomFieldsForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomFieldsForm, _super);
    function CustomFieldsForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.values = {};
        return _this;
    }
    CustomFieldsForm.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadCustomFields()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadLayouts()];
                    case 2:
                        _a.sent();
                        this.watchValue();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomFieldsForm.prototype.watchValue = function () {
        var parsedValue = this.parseValues();
        if (JSON.stringify(this.value) === JSON.stringify(parsedValue)) {
            return;
        }
        this.values = parsedValue;
    };
    Object.defineProperty(CustomFieldsForm.prototype, "fields", {
        // Return fields for type
        get: function () {
            return this.getCustomFields(this.type);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomFieldsForm.prototype, "layout", {
        get: function () {
            return this.getLayout(this.type);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomFieldsForm.prototype, "getValue", {
        // Get the value for a field
        get: function () {
            var _this = this;
            return function (id) {
                var _a;
                return _this.value && ((_a = _this.value.find(function (val) { return val.id === id; })) === null || _a === void 0 ? void 0 : _a.value);
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomFieldsForm.prototype, "fieldName", {
        // Get the field name for form submission
        get: function () {
            return function (field, index) {
                var name = 'custom_fields[' + index + '][value]';
                if (field.type === 'checkbox') {
                    name += '[]';
                }
                return name;
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomFieldsForm.prototype, "reduceValue", {
        // Return the value for custom field type with use of reduce function if present
        get: function () {
            var _this = this;
            return function (field, value) {
                var _a;
                var type = _this.custom(field.type);
                var params = (_a = type.formParams) !== null && _a !== void 0 ? _a : type.params;
                if (value && typeof value === 'object' && params && 'reduce' in params) {
                    return params.reduce(value);
                }
                return value;
            };
        },
        enumerable: false,
        configurable: true
    });
    CustomFieldsForm.prototype.filterFields = function (fields) {
        var filter = this.filter;
        if (!filter) {
            return fields;
        }
        return fields.filter(function (field) { return filter.includes(field.id); });
    };
    // Parse values to apply to local values
    CustomFieldsForm.prototype.parseValues = function () {
        var _this = this;
        var values = {};
        this.fields.forEach(function (field) {
            values[field.id] = _this.getValue(field.id);
        });
        return values;
    };
    // Get attributes for the field element
    CustomFieldsForm.prototype.getAttributes = function (field) {
        var extra = this.defaultTypes.includes(field.type) ? { params: {}, formParams: {} } : this.custom(field.type);
        return Object.assign({
            required: field.is_required,
            reduce: undefined
        }, extra.params, extra.formParams);
    };
    // Emit the values
    CustomFieldsForm.prototype.emitValues = function () {
        var _this = this;
        var values = [];
        this.fields.forEach(function (field) {
            values.push({
                id: field.id,
                label: field.label,
                type: field.type,
                value: _this.values[field.id]
            });
        });
        this.$emit('input', values);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomFieldsForm.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return []; } })
    ], CustomFieldsForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'custom_fields' })
    ], CustomFieldsForm.prototype, "name", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], CustomFieldsForm.prototype, "withTitle", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'form-title' })
    ], CustomFieldsForm.prototype, "titleClass", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomFieldsForm.prototype, "filter", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { deep: true })
    ], CustomFieldsForm.prototype, "watchValue", null);
    CustomFieldsForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('customFields', ['getCustomFields', 'getLayout'])), (0,external_vuex_.mapGetters)('user', ['currency'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('customFields', ['loadCustomFields', 'loadLayouts'])),
            components: {
                Spinner: interface_vue_.Spinner,
                KFormCheckbox: form_vue_.KFormCheckbox, KFormNumber: form_vue_.KFormNumber, KFormInput: form_vue_.KFormInput, KFormTextarea: form_vue_.KFormTextarea, KFormPhone: form_vue_.KFormPhone, KFormDatepicker: form_vue_.KFormDatepicker, KFormEditor: form_vue_.KFormEditor, KFormCheckboxGroup: form_vue_.KFormCheckboxGroup, KFormSelect: form_vue_.KFormSelect,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BFormRadio: external_bootstrap_vue_.BFormRadio, BInputGroup: external_bootstrap_vue_.BInputGroup, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            }
        })
    ], CustomFieldsForm);
    return CustomFieldsForm;
}((0,lib/* Mixins */.Xe)(CustomFieldsMixin/* default */.A)));
/* harmony default export */ var CustomFieldsFormvue_type_script_lang_ts_external = (CustomFieldsForm);

;// ./src/components/CustomFieldsForm/CustomFieldsForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomFieldsForm_CustomFieldsFormvue_type_script_lang_ts_external = (CustomFieldsFormvue_type_script_lang_ts_external); 
;// ./src/components/CustomFieldsForm/CustomFieldsForm.vue





/* normalize component */
;
var CustomFieldsForm_component = (0,componentNormalizer/* default */.A)(
  CustomFieldsForm_CustomFieldsFormvue_type_script_lang_ts_external,
  CustomFieldsFormvue_type_template_id_dec1f804_render,
  CustomFieldsFormvue_type_template_id_dec1f804_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomFieldsForm_CustomFieldsForm = (CustomFieldsForm_component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomFieldsDisplayTab/CustomFieldsDisplayTab.ts?vue&type=script&lang=ts&external








var CustomFieldsDisplayTab = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomFieldsDisplayTab, _super);
    function CustomFieldsDisplayTab() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.edit = false;
        return _this;
    }
    CustomFieldsDisplayTab.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadLayouts()];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CustomFieldsDisplayTab.prototype, "layout", {
        get: function () {
            return this.getLayout(this.type);
        },
        enumerable: false,
        configurable: true
    });
    CustomFieldsDisplayTab.prototype.submitComplete = function (response) {
        this.$emit('input', response.data);
        this.cancelForm();
    };
    CustomFieldsDisplayTab.prototype.cancelForm = function () {
        this.edit = false;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], CustomFieldsDisplayTab.prototype, "canUpdate", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomFieldsDisplayTab.prototype, "formUrl", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'b-tab' })
    ], CustomFieldsDisplayTab.prototype, "component", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomFieldsDisplayTab.prototype, "filter", void 0);
    CustomFieldsDisplayTab = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BTab: external_bootstrap_vue_.BTab, BButton: external_bootstrap_vue_.BButton, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol,
                Tab: interface_vue_.Tab,
                CustomFieldsForm: CustomFieldsForm_CustomFieldsForm,
                KForm: form_vue_.KForm, KFormStickyBar: form_vue_.KFormStickyBar
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('customFields', ['getLayout'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('customFields', ['loadLayouts']))
        })
    ], CustomFieldsDisplayTab);
    return CustomFieldsDisplayTab;
}((0,lib/* Mixins */.Xe)(CustomFieldsDisplay_CustomFieldsDisplay)));
/* harmony default export */ var CustomFieldsDisplayTabvue_type_script_lang_ts_external = (CustomFieldsDisplayTab);

;// ./src/components/CustomFieldsDisplayTab/CustomFieldsDisplayTab.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomFieldsDisplayTab_CustomFieldsDisplayTabvue_type_script_lang_ts_external = (CustomFieldsDisplayTabvue_type_script_lang_ts_external); 
;// ./src/components/CustomFieldsDisplayTab/CustomFieldsDisplayTab.vue





/* normalize component */
;
var CustomFieldsDisplayTab_component = (0,componentNormalizer/* default */.A)(
  CustomFieldsDisplayTab_CustomFieldsDisplayTabvue_type_script_lang_ts_external,
  CustomFieldsDisplayTabvue_type_template_id_5b3a7a78_render,
  CustomFieldsDisplayTabvue_type_template_id_5b3a7a78_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomFieldsDisplayTab_CustomFieldsDisplayTab = (CustomFieldsDisplayTab_component.exports);
;// ./src/mixins/CustomFieldsTableMixin.ts




var CustomFieldsTableMixin = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomFieldsTableMixin, _super);
    function CustomFieldsTableMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Load custom fields if needed
    CustomFieldsTableMixin.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadCustomFields()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CustomFieldsTableMixin.prototype, "customFieldTableColumns", {
        get: function () {
            var _this = this;
            return function (type) {
                return _this.getCustomFields(type).map(function (field) {
                    var render = null;
                    switch (field.type) {
                        case 'amount':
                            render = 'currency';
                            break;
                        case 'number':
                        case 'quantity':
                            render = 'number';
                            break;
                        case 'date':
                            render = 'date';
                            break;
                        case 'phone':
                            render = 'phone';
                            break;
                        case 'textarea':
                            render = 'textarea';
                            break;
                    }
                    var column = {
                        data: 'custom_fields',
                        exportKey: 'custom_field.' + field.id,
                        dataValue: function (data) {
                            var _a;
                            var value = (_a = data === null || data === void 0 ? void 0 : data.find(function (data) { return data.id === field.id; })) === null || _a === void 0 ? void 0 : _a.value;
                            if (!_this.defaultTypes.includes(field.type)) {
                                return _this.custom(field.type).view(value);
                            }
                            switch (field.type) {
                                case 'checkbox':
                                    if (value) {
                                        value = value.map(function (val) { return val.label; }).join(', ');
                                    }
                                    break;
                                case 'select':
                                case 'radio':
                                    if (value) {
                                        value = value.label;
                                    }
                                    break;
                            }
                            return value;
                        },
                        name: field.label,
                        visible: false,
                        sortable: field.type !== 'rich-editor',
                        sortableName: 'custom_fields-' + field.id,
                        isHtml: field.type === 'rich-editor' || field.type === 'textarea'
                    };
                    if (render) {
                        column.render = render;
                    }
                    return column;
                });
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomFieldsTableMixin.prototype, "customFieldTableFilters", {
        // Return filters params
        get: function () {
            var _this = this;
            return function (type) {
                var fields = _this.getCustomFields(type)
                    .filter(function (field) { return field.type !== 'rich-editor'; });
                return fields.map(function (field, i) {
                    return Object.assign({
                        label: field.label,
                        name: 'custom_fields[' + i + '][value]',
                        mapRequest: function (datas, value) {
                            if (!('custom_fields' in datas)) {
                                // If custom_fields not exists, add it in datas
                                datas['custom_fields'] = [];
                            }
                            // Prepare value
                            if (field.type === 'text' || field.type === 'phone') {
                                value = '%' + value + '%';
                            }
                            else if (Array.isArray(value)) {
                                value = value.join(',');
                            }
                            if (value !== '' && value !== undefined && value !== null) {
                                // Add value
                                datas['custom_fields'].push({
                                    id: field.id,
                                    value: value
                                });
                            }
                            return datas;
                        }
                    }, _this.filterType(field));
                });
            };
        },
        enumerable: false,
        configurable: true
    });
    // Return filter attributes based on filter type
    CustomFieldsTableMixin.prototype.filterType = function (field) {
        if (!this.defaultTypes.includes(field.type)) {
            var custom = this.custom(field.type);
            return (0,tslib_es6/* __assign */.Cl)({ type: 'select', multiple: true, params: custom.params }, custom.filterParams);
        }
        switch (field.type) {
            case 'amount':
            case 'number':
            case 'quantity':
                return {
                    type: 'number'
                };
            case 'date':
                return {
                    type: 'date'
                };
            case 'checkbox':
            case 'radio':
            case 'select':
                return {
                    type: 'select',
                    options: field.options,
                    multiple: true,
                    optionLabel: 'label',
                    value: 'id'
                };
            case 'phone':
                return {
                    type: 'phone'
                };
            default:
                return {
                    type: 'text'
                };
        }
    };
    CustomFieldsTableMixin = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('customFields', ['customFieldsLoaded'])), (0,external_vuex_.mapGetters)('customFields', ['getCustomFields'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('customFields', ['loadCustomFields']))
        })
    ], CustomFieldsTableMixin);
    return CustomFieldsTableMixin;
}((0,lib/* Mixins */.Xe)(CustomFieldsMixin/* default */.A)));
/* harmony default export */ var mixins_CustomFieldsTableMixin = (CustomFieldsTableMixin);

// EXTERNAL MODULE: ./src/views/CustomFieldsView.vue + 16 modules
var CustomFieldsView = __webpack_require__(4174);
;// ./src/lang/en.ts
var customFieldsLang = {};
/* harmony default export */ var en = ({
    customFields: customFieldsLang
});

;// ./src/lang/fr.ts
var fr_customFieldsLang = {
    menu: 'Champs personnalisés',
    pageTitle: 'Champs personnalisés',
    new: 'Création d\'un champ personnalisé',
    edit: 'Modification d\'un champ personnalisé',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce champ personnalisé ?',
    label: 'Nom du champ personnalisé',
    typeLabel: 'Type de champ',
    requiredLabel: 'Obligatoire',
    usageLabel: 'Utilisation',
    formTitle: 'Champs personnalisés',
    viewConfig: 'Sur une fiche, afficher les champs personnalisés dans un onglet dédié plutôt qu\'à la suite des autres informations.',
    layout: {
        button: 'Mise en page',
        title: 'Personnalisation de la mise en page des champs personnalisés',
        new: 'Création d\'une mise en page',
        edit: 'Modification d\'une mise en page',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette mise en page ?',
        elementTitle: 'Éléments concernés par la mise en page',
        layoutTitle: 'Mise en page',
        layoutExplain: 'La mise en page ne s\'applique, par défaut, qu\'aux formulaires. Si vous souhaitez appliquer cet affichage aux différentes fiches, vous devez afficher les informations des champs personnalisés dans un onglet dédié et non sur la partie de gauche, à la suite des autres informations.',
        showInTab: 'Afficher les champs personnalisés dans un onglet dédié',
        layoutElement: 'Éléments de mise en page',
        layoutDelete: 'Supprimer l\'élément de mise en page',
        placement: 'Emplacements'
    },
    types: {
        amount: 'Montant',
        checkbox: 'Cache à cocher multiple',
        date: 'Date',
        number: 'Nombre',
        phone: 'Téléphone',
        quantity: 'Quantité',
        radio: 'Cache à cocher unique',
        'rich-editor': 'Éditeur de texte avancé (gras, italique...)',
        select: 'Menu déroulant',
        text: 'Ligne de texte simple',
        textarea: 'Texte simple avec retour à la ligne'
    }
};
/* harmony default export */ var fr = ({
    customFields: fr_customFieldsLang
});

;// ./src/lang/index.ts


var Lang = {
    en: en,
    fr: fr
};
/* harmony default export */ var lang = (Lang);

;// ./src/router/configRoutes.ts
var configRoutes_CustomFieldsView = function () { return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 4174)); };
var routes = function (i18n) { return ([
    {
        name: 'custom-fields',
        path: 'custom-fields',
        component: configRoutes_CustomFieldsView,
        meta: {
            title: i18n.t('customFields.pageTitle'),
            userPermission: ['app-configuration', 1]
        }
    }
]); };
/* harmony default export */ var configRoutes = (routes);

;// ./src/menu/configs.ts
var configMenu = function (i18n) { return ([
    {
        label: i18n.t('customFields.menu'),
        path: '/configuration/custom-fields',
        icon: ['fas', 'sliders-v-square']
    }
]); };
/* harmony default export */ var configs = (configMenu);

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
;// ./node_modules/vuex-module-decorators/dist/esm/index.js
/**
 * Takes the properties on object from parameter source and adds them to the object
 * parameter target
 * @param {object} target  Object to have properties copied onto from y
 * @param {object} source  Object with properties to be copied to x
 */
function addPropertiesToObject(target, source) {
    var _loop_1 = function (k) {
        Object.defineProperty(target, k, {
            get: function () { return source[k]; }
        });
    };
    for (var _i = 0, _a = Object.keys(source || {}); _i < _a.length; _i++) {
        var k = _a[_i];
        _loop_1(k);
    }
}
/**
 * Returns a namespaced name of the module to be used as a store getter
 * @param module
 */
function getModuleName(module) {
    if (!module._vmdModuleName) {
        throw new Error("ERR_GET_MODULE_NAME : Could not get module accessor.\n      Make sure your module has name, we can't make accessors for unnamed modules\n      i.e. @Module({ name: 'something' })");
    }
    return "vuexModuleDecorators/".concat(module._vmdModuleName);
}

var VuexModule = /** @class */ (function () {
    function VuexModule(module) {
        this.actions = module.actions;
        this.mutations = module.mutations;
        this.state = module.state;
        this.getters = module.getters;
        this.namespaced = module.namespaced;
        this.modules = module.modules;
    }
    return VuexModule;
}());
function getModule(moduleClass, store) {
    var moduleName = getModuleName(moduleClass);
    if (store && store.getters[moduleName]) {
        return store.getters[moduleName];
    }
    else if (moduleClass._statics) {
        return moduleClass._statics;
    }
    var genStatic = moduleClass._genStatic;
    if (!genStatic) {
        throw new Error("ERR_GET_MODULE_NO_STATICS : Could not get module accessor.\n      Make sure your module has name, we can't make accessors for unnamed modules\n      i.e. @Module({ name: 'something' })");
    }
    var storeModule = genStatic(store);
    if (store) {
        store.getters[moduleName] = storeModule;
    }
    else {
        moduleClass._statics = storeModule;
    }
    return storeModule;
}

var reservedKeys = ['actions', 'getters', 'mutations', 'modules', 'state', 'namespaced', 'commit'];
function stateFactory(module) {
    var state = new module.prototype.constructor({});
    var s = {};
    Object.keys(state).forEach(function (key) {
        if (reservedKeys.indexOf(key) !== -1) {
            if (typeof state[key] !== 'undefined') {
                throw new Error("ERR_RESERVED_STATE_KEY_USED: You cannot use the following\n        ['actions', 'getters', 'mutations', 'modules', 'state', 'namespaced', 'commit']\n        as fields in your module. These are reserved as they have special purpose in Vuex");
            }
            return;
        }
        if (state.hasOwnProperty(key)) {
            if (typeof state[key] !== 'function') {
                s[key] = state[key];
            }
        }
    });
    return s;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function staticStateGenerator(module, modOpt, statics) {
    var state = modOpt.stateFactory ? module.state() : module.state;
    Object.keys(state).forEach(function (key) {
        if (state.hasOwnProperty(key)) {
            // If not undefined or function means it is a state value
            if (['undefined', 'function'].indexOf(typeof state[key]) === -1) {
                Object.defineProperty(statics, key, {
                    get: function () {
                        var path = modOpt.name.split('/');
                        var data = statics.store.state;
                        for (var _i = 0, path_1 = path; _i < path_1.length; _i++) {
                            var segment = path_1[_i];
                            data = data[segment];
                        }
                        return data[key];
                    }
                });
            }
        }
    });
}
function staticGetterGenerator(module, modOpt, statics) {
    Object.keys(module.getters).forEach(function (key) {
        if (module.namespaced) {
            Object.defineProperty(statics, key, {
                get: function () {
                    return statics.store.getters["".concat(modOpt.name, "/").concat(key)];
                }
            });
        }
        else {
            Object.defineProperty(statics, key, {
                get: function () {
                    return statics.store.getters[key];
                }
            });
        }
    });
}
function staticMutationGenerator(module, modOpt, statics) {
    Object.keys(module.mutations).forEach(function (key) {
        if (module.namespaced) {
            statics[key] = function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                (_a = statics.store).commit.apply(_a, __spreadArray(["".concat(modOpt.name, "/").concat(key)], args, false));
            };
        }
        else {
            statics[key] = function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                (_a = statics.store).commit.apply(_a, __spreadArray([key], args, false));
            };
        }
    });
}
function staticActionGenerators(module, modOpt, statics) {
    Object.keys(module.actions).forEach(function (key) {
        if (module.namespaced) {
            statics[key] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return __awaiter(this, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        return [2 /*return*/, (_a = statics.store).dispatch.apply(_a, __spreadArray(["".concat(modOpt.name, "/").concat(key)], args, false))];
                    });
                });
            };
        }
        else {
            statics[key] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return __awaiter(this, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        return [2 /*return*/, (_a = statics.store).dispatch.apply(_a, __spreadArray([key], args, false))];
                    });
                });
            };
        }
    });
}

function registerDynamicModule(module, modOpt) {
    if (!modOpt.name) {
        throw new Error('Name of module not provided in decorator options');
    }
    if (!modOpt.store) {
        throw new Error('Store not provided in decorator options when using dynamic option');
    }
    modOpt.store.registerModule(modOpt.name, // TODO: Handle nested modules too in future
    module, { preserveState: modOpt.preserveState || false });
}
function addGettersToModule(targetModule, srcModule) {
    Object.getOwnPropertyNames(srcModule.prototype).forEach(function (funcName) {
        var descriptor = Object.getOwnPropertyDescriptor(srcModule.prototype, funcName);
        if (descriptor.get && targetModule.getters) {
            targetModule.getters[funcName] = function (state, getters, rootState, rootGetters) {
                var thisObj = { context: { state: state, getters: getters, rootState: rootState, rootGetters: rootGetters } };
                addPropertiesToObject(thisObj, state);
                addPropertiesToObject(thisObj, getters);
                var got = descriptor.get.call(thisObj);
                return got;
            };
        }
    });
}
function moduleDecoratorFactory(moduleOptions) {
    return function (constructor) {
        var module = constructor;
        var stateFactory$1 = function () { return stateFactory(module); };
        if (!module.state) {
            module.state = moduleOptions && moduleOptions.stateFactory ? stateFactory$1 : stateFactory$1();
        }
        if (!module.getters) {
            module.getters = {};
        }
        if (!module.namespaced) {
            module.namespaced = moduleOptions && moduleOptions.namespaced;
        }
        var parentModule = Object.getPrototypeOf(module);
        while (parentModule.name !== 'VuexModule' && parentModule.name !== '') {
            addGettersToModule(module, parentModule);
            parentModule = Object.getPrototypeOf(parentModule);
        }
        addGettersToModule(module, module);
        var modOpt = moduleOptions;
        if (modOpt.name) {
            Object.defineProperty(constructor, '_genStatic', {
                value: function (store) {
                    var statics = { store: store || modOpt.store };
                    if (!statics.store) {
                        throw new Error("ERR_STORE_NOT_PROVIDED: To use getModule(), either the module\n            should be decorated with store in decorator, i.e. @Module({store: store}) or\n            store should be passed when calling getModule(), i.e. getModule(MyModule, this.$store)");
                    }
                    // ===========  For statics ==============
                    // ------ state -------
                    staticStateGenerator(module, modOpt, statics);
                    // ------- getters -------
                    if (module.getters) {
                        staticGetterGenerator(module, modOpt, statics);
                    }
                    // -------- mutations --------
                    if (module.mutations) {
                        staticMutationGenerator(module, modOpt, statics);
                    }
                    // -------- actions ---------
                    if (module.actions) {
                        staticActionGenerators(module, modOpt, statics);
                    }
                    return statics;
                }
            });
            Object.defineProperty(constructor, '_vmdModuleName', {
                value: modOpt.name
            });
        }
        if (modOpt.dynamic) {
            registerDynamicModule(module, modOpt);
        }
        return constructor;
    };
}
function Module(modOrOpt) {
    if (typeof modOrOpt === 'function') {
        /*
         * @Module decorator called without options (directly on the class definition)
         */
        moduleDecoratorFactory({})(modOrOpt);
    }
    else {
        /*
         * @Module({...}) decorator called with options
         */
        return moduleDecoratorFactory(modOrOpt);
    }
}

var config = {};

function actionDecoratorFactory(params) {
    var _a = params || {}, _b = _a.commit, commit = _b === void 0 ? undefined : _b, _c = _a.rawError, rawError = _c === void 0 ? !!config.rawError : _c, _d = _a.root, root = _d === void 0 ? false : _d;
    return function (target, key, descriptor) {
        var module = target.constructor;
        if (!module.hasOwnProperty('actions')) {
            module.actions = Object.assign({}, module.actions);
        }
        var actionFunction = descriptor.value;
        var action = function (context, payload) {
            return __awaiter(this, void 0, void 0, function () {
                var actionPayload, moduleName, moduleAccessor, thisObj, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 5, , 6]);
                            actionPayload = null;
                            if (!module._genStatic) return [3 /*break*/, 2];
                            moduleName = getModuleName(module);
                            moduleAccessor = context.rootGetters[moduleName]
                                ? context.rootGetters[moduleName]
                                : getModule(module);
                            moduleAccessor.context = context;
                            return [4 /*yield*/, actionFunction.call(moduleAccessor, payload)];
                        case 1:
                            actionPayload = _a.sent();
                            return [3 /*break*/, 4];
                        case 2:
                            thisObj = { context: context };
                            addPropertiesToObject(thisObj, context.state);
                            addPropertiesToObject(thisObj, context.getters);
                            return [4 /*yield*/, actionFunction.call(thisObj, payload)];
                        case 3:
                            actionPayload = _a.sent();
                            _a.label = 4;
                        case 4:
                            if (commit) {
                                context.commit(commit, actionPayload);
                            }
                            return [2 /*return*/, actionPayload];
                        case 5:
                            e_1 = _a.sent();
                            throw rawError
                                ? e_1
                                : new Error('ERR_ACTION_ACCESS_UNDEFINED: Are you trying to access ' +
                                    'this.someMutation() or this.someGetter inside an @Action? \n' +
                                    'That works only in dynamic modules. \n' +
                                    'If not dynamic use this.context.commit("mutationName", payload) ' +
                                    'and this.context.getters["getterName"]' +
                                    '\n' +
                                    new Error("Could not perform action ".concat(key.toString())).stack +
                                    '\n' +
                                    e_1.stack);
                        case 6: return [2 /*return*/];
                    }
                });
            });
        };
        module.actions[key] = root ? { root: root, handler: action } : action;
    };
}
/**
 * The @Action decorator turns an async function into an Vuex action
 *
 * @param targetOrParams the module class
 * @param key name of the action
 * @param descriptor the action function descriptor
 * @constructor
 */
function Action(targetOrParams, key, descriptor) {
    if (!key && !descriptor) {
        /*
         * This is the case when `targetOrParams` is params.
         * i.e. when used as -
         * <pre>
            @Action({commit: 'incrCount'})
            async getCountDelta() {
              return 5
            }
         * </pre>
         */
        return actionDecoratorFactory(targetOrParams);
    }
    else {
        /*
         * This is the case when @Action is called on action function
         * without any params
         * <pre>
         *   @Action
         *   async doSomething() {
         *    ...
         *   }
         * </pre>
         */
        actionDecoratorFactory()(targetOrParams, key, descriptor);
    }
}

function Mutation(target, key, descriptor) {
    var module = target.constructor;
    if (!module.hasOwnProperty('mutations')) {
        module.mutations = Object.assign({}, module.mutations);
    }
    var mutationFunction = descriptor.value;
    var mutation = function (state, payload) {
        mutationFunction.call(state, payload);
    };
    module.mutations[key] = mutation;
}

function mutationActionDecoratorFactory(params) {
    return function (target, key, descriptor) {
        var module = target.constructor;
        if (!module.hasOwnProperty('mutations')) {
            module.mutations = Object.assign({}, module.mutations);
        }
        if (!module.hasOwnProperty('actions')) {
            module.actions = Object.assign({}, module.actions);
        }
        var mutactFunction = descriptor.value;
        var action = function (context, payload) {
            return __awaiter(this, void 0, void 0, function () {
                var thisObj, actionPayload, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            thisObj = { context: context };
                            addPropertiesToObject(thisObj, context.state);
                            addPropertiesToObject(thisObj, context.getters);
                            return [4 /*yield*/, mutactFunction.call(thisObj, payload)];
                        case 1:
                            actionPayload = _a.sent();
                            if (actionPayload === undefined)
                                return [2 /*return*/];
                            context.commit(key, actionPayload);
                            return [3 /*break*/, 3];
                        case 2:
                            e_1 = _a.sent();
                            if (params.rawError) {
                                throw e_1;
                            }
                            else {
                                console.error('Could not perform action ' + key.toString());
                                console.error(e_1);
                                return [2 /*return*/, Promise.reject(e_1)];
                            }
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        var mutation = function (state, payload) {
            if (!params.mutate) {
                params.mutate = Object.keys(payload);
            }
            for (var _i = 0, _a = params.mutate; _i < _a.length; _i++) {
                var stateItem = _a[_i];
                if (state.hasOwnProperty(stateItem) && payload.hasOwnProperty(stateItem)) {
                    state[stateItem] = payload[stateItem];
                }
                else {
                    throw new Error("ERR_MUTATE_PARAMS_NOT_IN_PAYLOAD\n          In @MutationAction, mutate: ['a', 'b', ...] array keys must\n          match with return type = {a: {}, b: {}, ...} and must\n          also be in state.");
                }
            }
        };
        module.actions[key] = params.root ? { root: true, handler: action } : action;
        module.mutations[key] = mutation;
    };
}
/**
 * The @MutationAction decorator turns this into an action that further calls a mutation
 * Both the action and the mutation are generated for you
 *
 * @param paramsOrTarget the params or the target class
 * @param key the name of the function
 * @param descriptor the function body
 * @constructor
 */
function MutationAction(paramsOrTarget, key, descriptor) {
    if (!key && !descriptor) {
        /*
         * This is the case when `paramsOrTarget` is params.
         * i.e. when used as -
         * <pre>
            @MutationAction({mutate: ['incrCount']})
            async getCountDelta() {
              return {incrCount: 5}
            }
         * </pre>
         */
        return mutationActionDecoratorFactory(paramsOrTarget);
    }
    else {
        /*
         * This is the case when `paramsOrTarget` is target.
         * i.e. when used as -
         * <pre>
            @MutationAction
            async getCountDelta() {
              return {incrCount: 5}
            }
         * </pre>
         */
        mutationActionDecoratorFactory({})(paramsOrTarget, key, descriptor);
    }
}


//# sourceMappingURL=index.js.map

;// ./src/store/modules/CustomFieldsStore.ts



var CustomFieldsStore = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomFieldsStore, _super);
    function CustomFieldsStore() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.customFields = [];
        _this.customFieldsLoaded = false;
        _this.layouts = [];
        _this.layoutsLoaded = false;
        return _this;
    }
    // CLEAR STORE STATE
    CustomFieldsStore.prototype.clearStore = function () {
        var _this = this;
        var elements = ['Fields', 'Layouts'];
        elements.forEach(function (key) {
            _this.context.commit('set' + key, []);
            _this.context.commit('set' + key + 'Loaded', false);
        });
    };
    Object.defineProperty(CustomFieldsStore.prototype, "getCustomFields", {
        get: function () {
            var _this = this;
            return function (usage) {
                if (typeof usage === 'string') {
                    usage = [usage];
                }
                return _this.customFields.filter(function (field) {
                    return field.usage.some(function (use) { return usage.includes(use); });
                });
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomFieldsStore.prototype, "getCustomField", {
        get: function () {
            var _this = this;
            return function (id) { var _a; return (_a = _this.customFields.find(function (field) { return field.id === Number(id); })) !== null && _a !== void 0 ? _a : null; };
        },
        enumerable: false,
        configurable: true
    });
    CustomFieldsStore.prototype.setFieldsLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.customFieldsLoaded = state;
    };
    CustomFieldsStore.prototype.setFields = function (customFields) {
        this.customFields = customFields;
    };
    CustomFieldsStore.prototype.updateField = function (field) {
        if (!this.customFieldsLoaded) {
            return;
        }
        var index = this.customFields.findIndex(function (val) { return val.id === field.id; });
        if (index >= 0) {
            external_vue_default().set(this.customFields, index, field);
        }
        else {
            this.customFields.push(field);
        }
    };
    CustomFieldsStore.prototype.removeField = function (field) {
        if (!this.customFieldsLoaded) {
            return;
        }
        var index = this.customFields.findIndex(function (val) { return val.id === field.id; });
        if (index >= 0) {
            external_vue_default()["delete"](this.customFields, index);
        }
    };
    CustomFieldsStore.prototype.loadCustomFields = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var fields, page, loading, response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.customFieldsLoaded || force)) return [3 /*break*/, 5];
                        fields = [];
                        page = 1;
                        loading = true;
                        _a.label = 1;
                    case 1:
                        if (!loading) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwCustomFields.axios.get('/config/custom_field', {
                                params: {
                                    per_page: 500,
                                    page: page,
                                    sort: 'order',
                                    include: 'options'
                                }
                            })];
                    case 2:
                        response = _a.sent();
                        fields.push.apply(fields, response.data.data);
                        page++;
                        loading = page < response.data.meta.last_page;
                        return [3 /*break*/, 1];
                    case 3: return [4 /*yield*/, this.context.commit('setFields', fields)];
                    case 4:
                        _a.sent();
                        this.context.commit('setFieldsLoaded');
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    CustomFieldsStore.prototype.setCustomField = function (field) {
        this.context.commit('updateField', field);
        if (this.customFieldsLoaded) {
            this.context.commit('orderList');
        }
    };
    CustomFieldsStore.prototype.deleteCustomField = function (field) {
        this.context.commit('removeField', field);
    };
    Object.defineProperty(CustomFieldsStore.prototype, "getLayout", {
        get: function () {
            var _this = this;
            return function (usage) {
                var _a;
                if (typeof usage === 'string') {
                    usage = [usage];
                }
                var layout = (_a = _this.layouts.filter(function (layout) {
                    return layout.usages.some(function (use) { return usage.includes(use); });
                })[0]) !== null && _a !== void 0 ? _a : null;
                if (!layout) {
                    return [
                        {
                            size: 12,
                            contents: _this.getCustomFields(usage)
                        }
                    ];
                }
                var used = [];
                var usableLayout = layout.layout.map(function (layout) {
                    var newLayout = JSON.parse(JSON.stringify(layout));
                    newLayout.contents = newLayout.contents.map(function (fieldId) {
                        used.push(fieldId);
                        return _this.getCustomField(fieldId);
                    }).filter(function (field) {
                        return field && field.usage.some(function (use) { return usage.includes(use); });
                    });
                    return newLayout;
                });
                var missing = _this.getCustomFields(usage)
                    .map(function (field) { return String(field.id); })
                    .filter(function (fiedId) { return !used.includes(fiedId); })
                    .map(function (id) { return Number(id); });
                if (missing.length > 0) {
                    usableLayout.push({
                        size: 12,
                        contents: missing.map(function (fieldId) { return _this.getCustomField(fieldId); })
                    });
                }
                return usableLayout;
            };
        },
        enumerable: false,
        configurable: true
    });
    CustomFieldsStore.prototype.setLayoutsLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.layoutsLoaded = state;
    };
    CustomFieldsStore.prototype.setLayouts = function (layouts) {
        this.layouts = layouts;
    };
    CustomFieldsStore.prototype.updateLayout = function (layout) {
        if (!this.layoutsLoaded) {
            return;
        }
        var index = this.layouts.findIndex(function (val) { return val.id === layout.id; });
        if (index >= 0) {
            external_vue_default().set(this.layouts, index, layout);
        }
        else {
            this.layouts.push(layout);
        }
    };
    CustomFieldsStore.prototype.removeLayout = function (layout) {
        if (!this.layouts) {
            return;
        }
        var index = this.layouts.findIndex(function (val) { return val.id === layout.id; });
        if (index >= 0) {
            external_vue_default()["delete"](this.layouts, index);
        }
    };
    CustomFieldsStore.prototype.loadLayouts = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var layouts, page, loading, response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.layoutsLoaded || force)) return [3 /*break*/, 5];
                        layouts = [];
                        page = 1;
                        loading = true;
                        _a.label = 1;
                    case 1:
                        if (!loading) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwCustomFields.axios.get('/config/custom_field/layout', {
                                params: {
                                    per_page: 500,
                                    page: page
                                }
                            })];
                    case 2:
                        response = _a.sent();
                        layouts.push.apply(layouts, response.data.data);
                        page++;
                        loading = page < response.data.meta.last_page;
                        return [3 /*break*/, 1];
                    case 3: return [4 /*yield*/, this.context.commit('setLayouts', layouts)];
                    case 4:
                        _a.sent();
                        this.context.commit('setLayoutsLoaded');
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    CustomFieldsStore.prototype.setLayout = function (layout) {
        this.context.commit('updateLayout', layout);
    };
    CustomFieldsStore.prototype.deleteLayout = function (layout) {
        this.context.commit('removeLayout', layout);
    };
    // Sort a list alphabetically
    CustomFieldsStore.prototype.orderList = function () {
        this.customFields.sort(function (a, b) {
            var aKey = a.order;
            var bKey = b.order;
            if (aKey < bKey)
                return -1;
            else if (aKey > bKey)
                return 1;
            else
                return 0;
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CustomFieldsStore.prototype, "clearStore", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CustomFieldsStore.prototype, "setFieldsLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CustomFieldsStore.prototype, "setFields", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CustomFieldsStore.prototype, "updateField", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CustomFieldsStore.prototype, "removeField", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CustomFieldsStore.prototype, "loadCustomFields", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CustomFieldsStore.prototype, "setCustomField", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CustomFieldsStore.prototype, "deleteCustomField", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CustomFieldsStore.prototype, "setLayoutsLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CustomFieldsStore.prototype, "setLayouts", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CustomFieldsStore.prototype, "updateLayout", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CustomFieldsStore.prototype, "removeLayout", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CustomFieldsStore.prototype, "loadLayouts", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CustomFieldsStore.prototype, "setLayout", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CustomFieldsStore.prototype, "deleteLayout", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CustomFieldsStore.prototype, "orderList", null);
    CustomFieldsStore = (0,tslib_es6/* __decorate */.Cg)([
        Module({
            namespaced: true
        })
    ], CustomFieldsStore);
    return CustomFieldsStore;
}(VuexModule));
/* harmony default export */ var modules_CustomFieldsStore = (CustomFieldsStore);

// EXTERNAL MODULE: ./node_modules/lodash/forEach.js
var forEach = __webpack_require__(9754);
var forEach_default = /*#__PURE__*/__webpack_require__.n(forEach);
;// ./src/broadcasts/team.ts
/* harmony default export */ var team = (function (store) { return ([
    {
        name: '.FieldCreated',
        callback: function (field) {
            store.dispatch('customFields/setCustomField', field);
        }
    },
    {
        name: '.FieldUpdated',
        callback: function (field) {
            store.dispatch('customFields/setCustomField', field);
        }
    },
    {
        name: '.FieldDeleted',
        callback: function (field) {
            store.dispatch('customFields/deleteCustomField', field);
        }
    }
]); });

;// ./src/install.ts





var KwixeoCustomFields = {
    install: function (Vue, options) {
        // Install lang
        this.installLang(options);
        if (!options.fields) {
            options.fields = [];
        }
        Vue.prototype.$kwCustomFields = options;
        // Install VueX
        this.installVueX(options);
        // Install routes
        this.installRoutes(options);
        __webpack_require__(1848);
        // Initialize broadcasts
        this.installBroadcasts(Vue, options);
    },
    installVueX: function (options) {
        var store = options.store;
        // Register VueX modules
        var modules = {
            customFields: modules_CustomFieldsStore
        };
        forEach_default()(modules, function (module, key) {
            if (!store.hasModule(key)) {
                store.registerModule(key, module);
            }
        });
    },
    installRoutes: function (options) {
        var router = options.router;
        var i18n = options.i18n;
        configRoutes(i18n).forEach(function (route) {
            router.addRoute('configuration', route);
        });
    },
    installLang: function (options) {
        var i18n = options.i18n;
        forEach_default()(lang, function (messages, locale) {
            i18n.mergeLocaleMessage(locale, messages);
        });
    },
    installBroadcasts: function (Vue, options) {
        var broadcast = Vue.prototype.$broadcast;
        if (!broadcast) {
            return;
        }
        broadcast.registerListeners('team', team(options.store));
    }
};
/* harmony default export */ var install = (KwixeoCustomFields);

;// ./src/index.ts
// Individual components






// Mixins



// Individual view components







// Vue X Modules



;// ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js



}();
module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=customFields.common.js.map